import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StringService {
  constructor() {}

  /**
   * Normalizes a string to handle locale-specific characters.
   * @param str The string to normalize.
   * @returns The normalized string.
   */
  normalize(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
}
